<div *ngIf="gamification_flag"
    style="position: absolute;z-index:1000;width:100%;height: 100%;background: url('/assets/CV.gif');top:0px;background-size: auto;background-repeat: no-repeat;">
</div>